function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  transform: "translate(0.000000,64.000000) scale(0.100000,-0.100000)",
  fill: "current",
  stroke: "none"
}, /*#__PURE__*/React.createElement("path", {
  d: "M440 330 c0 -30 0 -30 -59 -30 -43 0 -60 -4 -65 -15 -8 -22 -171 -22 -180 0 -4 11 -22 15 -71 15 -69 0 -84 -13 -45 -38 17 -10 21 -10 26 3 4 8 12 15 20 15 17 0 18 -17 2 -23 -7 -3 5 -3 27 -2 88 7 233 7 244 1 6 -4 14 0 17 8 3 9 12 16 20 16 17 0 18 -17 2 -23 -7 -2 1 -4 19 -3 17 1 35 4 38 8 4 4 29 4 56 1 29 -3 49 -2 49 4 0 14 44 10 53 -5 7 -11 12 -10 27 5 28 29 9 53 -45 53 -25 0 -45 5 -45 10 0 6 6 10 13 11 6 1 1 4 -13 8 -14 5 -29 4 -34 -1 -6 -4 -19 -8 -30 -7 -18 1 -17 2 4 9 l25 8 -27 1 c-25 1 -28 -3 -28 -29z m-320 -60 c0 -5 -4 -10 -10 -10 -5 0 -10 5 -10 10 0 6 5 10 10 10 6 0 10 -4 10 -10z m310 0 c0 -5 -4 -10 -10 -10 -5 0 -10 5 -10 10 0 6 5 10 10 10 6 0 10 -4 10 -10z"
}));

var SvgVehicle5 = function SvgVehicle5(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "64.000000pt",
    height: "64.000000pt",
    viewBox: "0 0 64.000000 64.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgVehicle5, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/vehicle5.4cf518cd.svg";
export { ForwardRef as ReactComponent };